import images from "../../assets/products/images";

const products = [
  {
    name: "Essential White T-shirt",
    price: 12.5,
    gender: "men",
    cat: "tshirts",
    image: images.men.tshirt[0],
  },
  {
    name: "Essential Black Long sleeves T-shirt",
    price: 14.9,
    gender: "men",
    cat: "tshirts",
    image: images.men.tshirt[1],
  },
  {
    name: "Essential Grey T-shirt",
    price: 12,
    gender: "men",
    cat: "tshirts",
    image: images.men.tshirt[2],
  },
  {
    name: "Long sleeves Baseball T-shirt",
    price: 16.9,
    gender: "men",
    cat: "tshirts",
    image: images.men.tshirt[3],
  },
  {
    name: "White tight fit premium T-shirt",
    price: 16.5,
    gender: "men",
    cat: "tshirts",
    image: images.men.tshirt[4],
  },
  {
    name: "Essential Yellow T-shirt",
    price: 11,
    gender: "men",
    cat: "tshirts",
    image: images.men.tshirt[5],
  },
  {
    name: "Essential Red Polo-shirt",
    price: 22.9,
    gender: "men",
    cat: "tshirts",
    image: images.men.tshirt[6],
  },
  {
    name: "Essential Black Om logo T-shirt",
    price: 9.85,
    gender: "men",
    cat: "tshirts",
    image: images.men.tshirt[7],
  },
  {
    name: "Essential Red T-shirt",
    price: 12.5,
    gender: "men",
    cat: "tshirts",
    image: images.men.tshirt[8],
  },
  {
    name: "Essential Blue premium T-shirt",
    price: 17.9,
    gender: "men",
    cat: "tshirts",
    image: images.men.tshirt[9],
  },
  {
    name: "Essential White Polo-shirt",
    price: 20.5,
    gender: "men",
    cat: "tshirts",
    image: images.men.tshirt[10],
  },
  {
    name: "Essential Yellow T-shirt",
    price: 11.1,
    gender: "men",
    cat: "tshirts",
    image: images.men.tshirt[11],
  },
  {
    name: "Green loose-fitting Shirt",
    price: 19.5,
    gender: "women",
    cat: "tshirts",
    image: images.women.tshirt[6],
  },
  {
    name: "Blue and Red summer Top",
    price: 32.5,
    gender: "women",
    cat: "tshirts",
    image: images.women.tshirt[0],
  },
  {
    name: "Essential Red crop-top",
    price: 29.9,
    gender: "women",
    cat: "tshirts",
    image: images.women.tshirt[7],
  },
  {
    name: "Essential Red V-neck T-shirt",
    price: 12.5,
    gender: "women",
    cat: "tshirts",
    image: images.women.tshirt[4],
  },
  {
    name: "Pink Off shoulder Crop-top",
    price: 21.4,
    gender: "women",
    cat: "tshirts",
    image: images.women.tshirt[8],
  },
  {
    name: "Red Crop-top",
    price: 19.5,
    gender: "women",
    cat: "tshirts",
    image: images.women.tshirt[3],
  },
  {
    name: "Essential White V-neck T-shirt",
    price: 10,
    gender: "women",
    cat: "tshirts",
    image: images.women.tshirt[5],
  },
  {
    name: "Grey Baseball T-shirt",
    price: 16.5,
    gender: "women",
    cat: "tshirts",
    image: images.women.tshirt[1],
  },
  {
    name: "Purple Sport T-shirt",
    price: 12,
    gender: "women",
    cat: "tshirts",
    image: images.women.tshirt[9],
  },
  {
    name: "Rocket logo Blue T-shirt",
    price: 4.2,
    gender: "women",
    cat: "tshirts",
    image: images.women.tshirt[2],
  },
  {
    name: "White Short-sleeves Shirt",
    price: 25,
    gender: "men",
    cat: "shirts",
    image: images.men.shirt[0],
  },
  {
    name: "Light blue Long-sleeves Shirt",
    price: 28,
    gender: "men",
    cat: "shirts",
    image: images.men.shirt[1],
  },
  {
    name: "Light grey Long-sleeves Shirt",
    price: 29,
    gender: "men",
    cat: "shirts",
    image: images.men.shirt[2],
  },
  {
    name: "Light blue Long-sleeves checkered Shirt",
    price: 19,
    gender: "men",
    cat: "shirts",
    image: images.men.shirt[3],
  },
  {
    name: "Red and Blue Short-sleeves checkered Shirt",
    price: 18.5,
    gender: "men",
    cat: "shirts",
    image: images.men.shirt[4],
  },
  {
    name: "White Long-sleeves Shirt",
    price: 29.9,
    gender: "men",
    cat: "shirts",
    image: images.men.shirt[5],
  },
  {
    name: "Crimson Short-sleeves Shirt",
    price: 22.7,
    gender: "men",
    cat: "shirts",
    image: images.men.shirt[6],
  },
  {
    name: "Orange and blue Long-sleeves checkered Shirt",
    price: 19.8,
    gender: "men",
    cat: "shirts",
    image: images.men.shirt[7],
  },
  {
    name: "Oh hi there, hire me!",
    price: 0,
    gender: "men",
    cat: "shirts",
    image: images.men.shirt[8],
  },
  {
    name: "Yellow and pink Mid Dress",
    price: 59.9,
    gender: "women",
    cat: "shirts",
    image: images.women.dress[0],
  },
  {
    name: "Pink Dress",
    price: 45.9,
    gender: "women",
    cat: "shirts",
    image: images.women.dress[1],
  },
  {
    name: "Yellow Long Dress",
    price: 67,
    gender: "women",
    cat: "shirts",
    image: images.women.dress[2],
  },
  {
    name: "Red Long Dress",
    price: 88,
    gender: "women",
    cat: "shirts",
    image: images.women.dress[3],
  },
  {
    name: "Red Short Dress",
    price: 39.9,
    gender: "women",
    cat: "shirts",
    image: images.women.dress[4],
  },
  {
    name: "Red Medium Dress",
    price: 42,
    gender: "women",
    cat: "shirts",
    image: images.women.dress[5],
  },
  {
    name: "Ligh grey Sweater",
    price: 27.5,
    gender: "men",
    cat: "sweaters",
    image: images.men.sweater[0],
  },
  {
    name: "Black sweater",
    price: 27.9,
    gender: "men",
    cat: "sweaters",
    image: images.men.sweater[1],
  },
  {
    name: "Blue sweater",
    price: 27.9,
    gender: "men",
    cat: "sweaters",
    image: images.men.sweater[2],
  },
  {
    name: "Red sweater",
    price: 31.1,
    gender: "men",
    cat: "sweaters",
    image: images.men.sweater[3],
  },
  {
    name: "Black Logo sweater",
    price: 32,
    gender: "men",
    cat: "sweaters",
    image: images.men.sweater[4],
  },
  {
    name: "Black and white sweater",
    price: 29.9,
    gender: "men",
    cat: "sweaters",
    image: images.men.sweater[5],
  },
  {
    name: "Red and grey sweater",
    price: 27,
    gender: "men",
    cat: "sweaters",
    image: images.men.sweater[6],
  },
  {
    name: "Grey South85 Hoodie",
    price: 30,
    gender: "men",
    cat: "sweaters",
    image: images.men.sweater[7],
  },
  {
    name: "Black and white striped sweater",
    price: 28,
    gender: "men",
    cat: "sweaters",
    image: images.men.sweater[8],
  },
  {
    name: "Yellow sweater",
    price: 30,
    gender: "men",
    cat: "sweaters",
    image: images.men.sweater[9],
  },
  {
    name: "Grey Hoodie",
    price: 34,
    gender: "men",
    cat: "sweaters",
    image: images.men.sweater[10],
  },
  {
    name: "Yellow Sweater",
    price: 29.9,
    gender: "women",
    cat: "sweaters",
    image: images.women.sweater[0],
  },
  {
    name: "Orange Zip-up Hoodie",
    price: 38.7,
    gender: "women",
    cat: "sweaters",
    image: images.women.sweater[1],
  },
  {
    name: "Black Loose Sweater",
    price: 30.4,
    gender: "women",
    cat: "sweaters",
    image: images.women.sweater[2],
  },
  {
    name: "Red Knit Sweater",
    price: 37,
    gender: "women",
    cat: "sweaters",
    image: images.women.sweater[3],
  },
  {
    name: "Grey Short Turtle-neck Sweater",
    price: 39.8,
    gender: "women",
    cat: "sweaters",
    image: images.women.sweater[4],
  },
  {
    name: "Beige Long Turtle-neck Sweater",
    price: 35,
    gender: "women",
    cat: "sweaters",
    image: images.women.sweater[5],
  },
  {
    name: "Brown Hoodie",
    price: 26.2,
    gender: "women",
    cat: "sweaters",
    image: images.women.sweater[6],
  },
  {
    name: "Red Hoodie",
    price: 49.9,
    gender: "women",
    cat: "sweaters",
    image: images.women.sweater[7],
  },
  {
    name: "Black Flower print Sweater",
    price: 31,
    gender: "women",
    cat: "sweaters",
    image: images.women.sweater[8],
  },
  {
    name: "Green Hood Parka",
    price: 79.9,
    gender: "men",
    cat: "jackets",
    image: images.men.jacket[1],
  },
  {
    name: "Blue Jeans Jacket",
    price: 45.5,
    gender: "men",
    cat: "jackets",
    image: images.men.jacket[2],
  },
  {
    name: "Yellow Puffer Jacket",
    price: 62.1,
    gender: "men",
    cat: "jackets",
    image: images.men.jacket[3],
  },
  {
    name: "Black Jeans Jacket",
    price: 38.8,
    gender: "men",
    cat: "jackets",
    image: images.men.jacket[4],
  },
  {
    name: "Green Parka",
    price: 119.9,
    gender: "men",
    cat: "jackets",
    image: images.men.jacket[5],
  },
  {
    name: "Multi-color Puffer Jacket",
    price: 145.9,
    gender: "men",
    cat: "jackets",
    image: images.men.jacket[6],
  },
  {
    name: "Blue Puffer Jacket",
    price: 68.4,
    gender: "men",
    cat: "jackets",
    image: images.men.jacket[7],
  },
  {
    name: "Red Windbreaker",
    price: 189.9,
    gender: "men",
    cat: "jackets",
    image: images.men.jacket[8],
  },
  {
    name: "Black Puffer Jacket",
    price: 45.7,
    gender: "men",
    cat: "jackets",
    image: images.men.jacket[9],
  },
  {
    name: "Light Blue Sports Jacket",
    price: 75,
    gender: "men",
    cat: "jackets",
    image: images.men.jacket[10],
  },
  {
    name: "Grey Coat",
    price: 99.9,
    gender: "men",
    cat: "jackets",
    image: images.men.jacket[11],
  },
  {
    name: "Leather Jacket",
    price: 160.7,
    gender: "men",
    cat: "jackets",
    image: images.men.jacket[0],
  },
  {
    name: "Orange Sports Jacket",
    price: 98.7,
    gender: "women",
    cat: "jackets",
    image: images.women.jacket[0],
  },
  {
    name: "Blue Coat",
    price: 178.4,
    gender: "women",
    cat: "jackets",
    image: images.women.jacket[1],
  },
  {
    name: "Beige Coat",
    price: 79.8,
    gender: "women",
    cat: "jackets",
    image: images.women.jacket[2],
  },
  {
    name: "Light blue Jeans Jacket",
    price: 39.6,
    gender: "women",
    cat: "jackets",
    image: images.women.jacket[3],
  },
  {
    name: "Red Coat",
    price: 199.8,
    gender: "women",
    cat: "jackets",
    image: images.women.jacket[4],
  },
  {
    name: "White Windbreaker",
    price: 112.7,
    gender: "women",
    cat: "jackets",
    image: images.women.jacket[5],
  },
  {
    name: "Light orange Puffer Jacket",
    price: 125,
    gender: "women",
    cat: "jackets",
    image: images.women.jacket[6],
  },
  {
    name: "Yellow Coat",
    price: 65,
    gender: "women",
    cat: "jackets",
    image: images.women.jacket[7],
  },
  {
    name: "Black Parka",
    price: 99,
    gender: "women",
    cat: "jackets",
    image: images.women.jacket[8],
  },
  {
    name: "White Hood Parka",
    price: 145.9,
    gender: "women",
    cat: "jackets",
    image: images.women.jacket[9],
  },
  {
    name: "Green Fluffy Parka",
    price: 72,
    gender: "women",
    cat: "jackets",
    image: images.women.jacket[10],
  },
];

export default products;
